import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { HiddenProps } from './types';
import HiddenLayout from './HiddenLayout';

const MatureAgeBlockedOverlay: React.FC<HiddenProps> = ({
  deviation,
  overrideMatureFilter,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <HiddenLayout
      deviation={deviation}
      icon={<HiddenIcon size={IconSize.HUGE} />}
      text={t('deviationview.blocked.mature.text')}
      {...props}
    />
  );
};
MatureAgeBlockedOverlay.displayName = 'MatureAgeBlockedOverlay';

export default MatureAgeBlockedOverlay;
